function parseLaneStop(laneStop = '') {
  const [description, latStr, lngStr, radiusStr] = laneStop.split(':')
  const radius = parseInt(radiusStr, 10) || 0

  if (!latStr || !lngStr) {
    return undefined
  }

  return {
    ...(description && { description }),
    ...(radius && { radius }),
    lat: parseFloat(latStr, 10) || undefined,
    lng: parseFloat(lngStr, 10) || undefined,
  }
}

function parseLanesQueryString(lanesStr = '') {
  if (!lanesStr || lanesStr.length <= 0) {
    return []
  }

  return lanesStr.split('|').map(someLane => {
    const [pickupStr, deliveryStr] = someLane.split(';')
    const pickup = parseLaneStop(pickupStr)
    const delivery = parseLaneStop(deliveryStr)
    const radius = pickup?.radius || delivery?.radius

    return {
      pickup,
      delivery,
      ...(radius && { radius }),
    }
  })
}

export { parseLanesQueryString }
